import React from "react";
import { Box, Chip } from "@mui/material";

const ChipListBox = ({ mappedData = [], name, onClick }) => {
  const isDisabled = !mappedData || mappedData.length === 0;

  return (
    <Box
      onClick={!isDisabled ? () => onClick(mappedData, name) : undefined}
      sx={{
        height: "40px",
        marginTop: "5px",
        width: "180px",
        display: "flex",
        overflowY: "auto",
        flexWrap: "wrap",
        gap: "4px",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        transition: "all 0.3s ease",
        cursor: isDisabled ? "default" : "pointer",
        backgroundColor: isDisabled ? "#f0f0f0" : "white",
        opacity: isDisabled ? 0.6 : 1,
      }}
    >
      {mappedData?.map((option, index) => (
        <Chip label={option} key={index} />
      ))}
    </Box>
  );
};

export default ChipListBox;
